const ErrorModal = ({ errorModalRef }) => {
  return (
    <>
      {/* Result Modal */}
      <div className="modal fade" ref={errorModalRef} id="modalError" tabIndex="-1" aria-labelledby="modalErrorTitle" aria-hidden="true">
        <div className="modal-dialog modal-lg">
          <div className="modal-content px-4 py-3">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="modalErrorTitle">Oops!</h1>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              Something is wrong. Sorry for the inconvenience. Please try again later.
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default ErrorModal